import type { SvgIconProps } from '@mui/material';
import { SvgIcon } from '@mui/material';

export function CohortRetentionIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21 8C22.1046 8 23 7.10457 23 6V5C23 2.79086 21.2091 1 19 1H18H16H13H11H8H6H5C2.79086 1 1 2.79086 1 5V6V8V11V13V16V18V19C1 21.2091 2.79086 23 5 23H6L6.02653 22.9735C7.11213 22.9881 8 22.112 8 21.0264V21V18H11C12.1046 18 13 17.1046 13 16V13H16C17.1046 13 18 12.1046 18 11V8H21ZM8 3V6H11V3H8ZM16 6H13V3H16V6ZM18 6H21V5C21 4.63571 20.9026 4.29417 20.7324 4C20.5568 3.69637 20.3036 3.4432 20 3.26756C19.7058 3.09739 19.3643 3 19 3H18V6ZM8 16H11V13H8V16ZM6 21V18H3V19C3 19.3643 3.09739 19.7058 3.26756 20C3.4432 20.3036 3.69637 20.5568 4 20.7324C4.29417 20.9026 4.63571 21 5 21H6ZM6 16H3V13H6V16ZM16 11H13V8H16V11ZM8 11H11V8H8V11ZM6 11H3V8H6V11ZM6 6H3V5C3 4.63571 3.09739 4.29417 3.26756 4C3.4432 3.69637 3.69637 3.4432 4 3.26756C4.29417 3.09739 4.63571 3 5 3H6V6Z"
          fill="currentColor"
        />
        <path d="M3 16H6V13H3V16Z" fill="currentColor" />
        <path
          d="M21 6H18V3H19C19.3643 3 19.7058 3.09739 20 3.26756C20.3036 3.4432 20.5568 3.69637 20.7324 4C20.9026 4.29417 21 4.63571 21 5V6Z"
          fill="currentColor"
        />
        <path
          d="M3 6H6V3H5C4.63571 3 4.29417 3.09739 4 3.26756C3.69637 3.4432 3.4432 3.69637 3.26756 4C3.09739 4.29417 3 4.63571 3 5V6Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}
